// extracted by mini-css-extract-plugin
export default {"card":"style_card__bYnkj","text":"style_text__jTnrp","button":"style_button__px-Ro"};